import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from '../../../environments/environment';
import { routerTransition } from '../../router.animations';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': ''}
})
export class BlogComponent implements OnInit {
  articles: Array<any> = null;
  baseUrl: string = environment.baseUrl;
  language: string;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.articles = data.articles;
    });
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.language = params.get('language');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/blog/blog.component.ts